/* The mockup's `.otp`: six 44px boxes, tabular digits.
 * `minmax(0, 1fr)`, not `1fr`: a `1fr` track has an `auto` minimum, and an <input> has an intrinsic
 * min-content width of about 20 characters, so each box grew to hundreds of pixels and the row
 * overflowed. With a zero minimum the six tracks share the 320px and each box stretches to its
 * track (about 47px in Chromium, Firefox and WebKit). */
.otp {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: var(--space-2);
  max-inline-size: 320px;
  margin-block-start: var(--space-2);
}

.box {
  block-size: 44px;
  padding: 0;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font-size: var(--font-size-20);
  font-variant-numeric: tabular-nums;
  text-align: center;
}

.box[aria-invalid="true"] {
  border-color: var(--danger-text);
}

.box:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 1px;
}
